import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '@components/layouts/dialog/dialog.component';

interface IMobileAppDialogData {
  isAndroid: boolean;
  isiOS: boolean;
}

@Component({
  selector: 'kzn-open-mobile-app',
  standalone: true,
  imports: [DialogComponent],
  templateUrl: './open-mobile-app.component.html',
  styleUrl: './open-mobile-app.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class OpenMobileAppComponent {
  dialogData: IMobileAppDialogData = {
    isAndroid: false,
    isiOS: false,
  }
  appStoreUrl: string = 'href="https://apps.apple.com/in/iphone/search?term=kaizen%20esign';
  playStoreUrl: string = 'https://play.google.com/store/apps/details?id=com.ayankaizen.esign';
  private deepLinkScheme: string = 'kaizen';

  constructor(
    private dialogRef: MatDialogRef<OpenMobileAppComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: IMobileAppDialogData
  ) {
    this.dialogData = data;
  }

  openMobileApp(): void {
    sessionStorage.setItem('skipOpenAppPrompt', '1');
    this.dialogRef.close();
    const emailHitUrl = window.location.href;
    const encodedUrl = encodeURIComponent(emailHitUrl);
    console.log('Open app URL:', emailHitUrl);
    const deepLinkUrl = `${this.deepLinkScheme}://open?url=${encodedUrl}`;
    const fallbackUrl = this.dialogData.isiOS ? this.appStoreUrl : this.playStoreUrl;
    const fallbackDelayMs = 1200;

    if (this.dialogData.isAndroid) {
      const intentUrl = `intent://open?url=${encodedUrl}#Intent;scheme=${this.deepLinkScheme};package=com.ayankaizen.esign;S.url=${encodedUrl};end`;
      window.location.href = intentUrl;
    } else {
      window.location.href = deepLinkUrl;
    }

    if (fallbackUrl) {
      window.setTimeout(() => {
        window.location.href = fallbackUrl;
      }, fallbackDelayMs);
    }
  }

  continueInBrowser(): void {
    this.dialogRef.close();
  }
}
